const translations = {
  english: {
    title: 'i24NEWS TikTok video',
  },
  french: {
    title: 'video TikTok d\'i24NEWS',
  },
  arabic: {
    title: 'فيديو تيك توك لـ i24NEWS',
  },
  hebrew: {
    title: 'סרטון טיקטוק של i24NEWS',
  },
}
  
export default translations
